import React from 'react';
import Header from 'components/Header';
import Router from 'router';
import { isBrowser } from "react-device-detect";
import { NavLink } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import { connect } from 'react-redux';
import './layout.scss';
import ProfilePicture from 'components/ProfilePicture';
import UserFullName from 'components/UseFullName';
import Career from 'components/Career';

const whiteWords = {
    color: "white",
}

const inline = {
    display: 'inline'
}

const bold = {
    fontWeight: "bold"
}

const navLinkStyle = {
    ...whiteWords,
    textDecoration: 'none',
    fontSize: 15
}

const activeNavLinkStyle = {
    ...whiteWords,
    ...bold,
}

const liPadding = {
    paddingTop: 5,
    paddingBottom: 5
}

const navLinkStyleG = {
    color: "#535c68",
    textDecoration: 'none',
    fontSize: 15
}

const activeNavLinkStyleG = {
    ...bold,
    color: "#535c68",
}

const userNameStyle = {
    ...activeNavLinkStyle,
    marginTop: 15,
    fontSize: 15,
    textTransform: 'capitalize'
}

const iconMR = {
    marginLeft: 10,

    marginRight: 10,
    width: 15
}

const iconThinMR = {
    marginLeft: 10,
    marginRight: 13,
    width: 15
}

const isRequiredModule = {
    ...inline,
    color: '#d63031',
}

const jobInformationStyle = {
    ...whiteWords,
    marginTop: 5,
    fontSize: 15
}

const sidebarWrapper = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 10
}

const userProfilePicture = {
    width: 100,
    height: 'auto'
}


class Layout extends React.Component {

    state = {
        drawerPos: isBrowser ? 2 : 0
    };

    handleDrawer = () => {
        if (this.state.drawerPos < 2) {
            this.setState((state) => ({
                drawerPos: state.drawerPos + 2
            }));
        } else {
            this.setState({
                drawerPos: 0
            })
        }
    };

    render() {
        let drawerClass = [];
        let mainClass = [];
        if (this.state.drawerPos === 1) {
            drawerClass.push("drawerMin");
            mainClass.push("mainMin")
        } else if (this.state.drawerPos === 2) {
            if (isBrowser) {
                drawerClass.push("drawerOpen");
            } else {
                drawerClass.push("drawerOpenMobile");
            }
            mainClass.push("mainOpen");
        } else {
            drawerClass = [];
            mainClass = [];
        }
        return (
            <>
                <div className="App">
                    <Header toggleSidebar={this.handleDrawer} />
                    <aside className={drawerClass.join(" ")} >
                        <br />
                        <div style={sidebarWrapper}>
                            <div style={userProfilePicture}>
                                <ProfilePicture size={100} />
                            </div>
                            <span style={userNameStyle}>
                                <UserFullName />
                            </span>
                            <span style={jobInformationStyle}>
                                <Career />
                                {/* { this.props.user.persona.profesionUI } */}
                            </span>
                        </div>

                        <ul>
                            <li style={liPadding}>
                                <NavLink
                                    to="/"
                                    exact
                                    style={navLinkStyle}
                                    activeStyle={activeNavLinkStyle}
                                >
                                    <i style={iconMR} className="fa fa-user-clock"></i> Datos personales
                                    {
                                        this.props.hasPersonalDataReducer &&
                                        <div style={inline}>
                                            {' '}<i className="fa fa-check"></i>
                                        </div>
                                    }

                                    {
                                        (this.props.isRequiredModuleReducer && !this.props.hasPersonalDataReducer) &&
                                        <div style={isRequiredModule}>
                                            {' '}<i class="fa fa-exclamation"></i>
                                        </div>
                                    }

                                </NavLink>
                            </li>
                            {
                                this.props.user.esEmpleado &&
                                <li style={liPadding}>
                                    <NavLink
                                        to="/familyStructure"
                                        style={navLinkStyle}
                                        activeStyle={activeNavLinkStyle}
                                    >
                                        <i style={iconMR} className="fa fa-house-user"></i> Estructura familiar
                                        {
                                            this.props.hasFamilyStructureDataReducer &&
                                            <div style={inline}>
                                                {' '}<i className="fa fa-check"></i>
                                            </div>
                                        }
                                    </NavLink>
                                </li>
                            }
                            {
                                this.props.user.esEmpleado &&
                                <li style={liPadding}>
                                    <NavLink
                                        to="/vehicle"
                                        style={navLinkStyle}
                                        activeStyle={activeNavLinkStyle}
                                    >
                                        <i style={iconMR} className="fa fa-car"></i> Vehículo
                                        {
                                            this.props.hasVehicleDataReducer &&
                                            <div style={inline}>
                                                {' '}<i className="fa fa-check"></i>
                                            </div>
                                        }
                                    </NavLink>
                                </li>
                            }

                            <li style={liPadding}>
                                <NavLink
                                    to="/education"
                                    style={navLinkStyle}
                                    activeStyle={activeNavLinkStyle}
                                >
                                    <i style={iconMR} className="fa fa-school"></i> Educación
                                    {
                                        this.props.hasEducationDataReducer &&
                                        <div style={inline}>
                                            {' '}<i className="fa fa-check"></i>
                                        </div>
                                    }
                                    {
                                        (this.props.isRequiredModuleReducer && !this.props.hasEducationDataReducer) &&
                                        <div style={isRequiredModule}>
                                            {' '}<i class="fa fa-exclamation"></i>
                                        </div>
                                    }
                                </NavLink>
                            </li>
                            <li style={liPadding}>
                                <NavLink
                                    to="/language"
                                    style={navLinkStyle}
                                    activeStyle={activeNavLinkStyle}
                                >
                                    <i style={iconMR} className="fa fa-globe"></i> Idiomas
                                    {
                                        this.props.hasLanguageDataReducer &&
                                        <div style={inline}>
                                            {' '}<i className="fa fa-check"></i>
                                        </div>
                                    }
                                </NavLink>
                            </li>
                            {
                                this.props.user.esEmpleado &&
                                <li style={liPadding}>
                                    <NavLink
                                        to="/talents"
                                        style={navLinkStyle}
                                        activeStyle={activeNavLinkStyle}
                                    >
                                        <div style={{ display: 'flex' }}>
                                            <i style={iconThinMR} class="fas fa-magic"></i>
                                            <span style={{ textAlign: 'justify' }}>
                                                Talentos
                                                {
                                                    this.props.hasTalentsDataReducer &&
                                                    <div style={inline}>
                                                        {' '}<i className="fa fa-check"></i>
                                                    </div>
                                                }
                                                {
                                                    (this.props.isRequiredModuleReducer && !this.props.hasTalentsDataReducer) &&
                                                    <div style={isRequiredModule}>
                                                        {' '}<i class="fa fa-exclamation"></i>
                                                    </div>
                                                }
                                            </span>
                                        </div>
                                    </NavLink>
                                </li>
                            }
                            <li style={liPadding}>
                                <NavLink
                                    to="/knowledgeAndSkillsModule"
                                    style={navLinkStyle}
                                    activeStyle={activeNavLinkStyle}
                                >
                                    <div style={{ display: 'flex' }}>
                                        <i style={iconThinMR} className="fa fa-snowboarding"></i>
                                        <span style={{ textAlign: 'justify' }}>
                                            Conocimientos y habilidades
                                            {
                                                this.props.hasKnowledgeDataReducer &&
                                                <div style={inline}>
                                                    {' '}<i className="fa fa-check"></i>
                                                </div>
                                            }
                                            {
                                                (this.props.isRequiredModuleReducer && !this.props.hasKnowledgeDataReducer) &&
                                                <div style={isRequiredModule}>
                                                    {' '}<i class="fa fa-exclamation"></i>
                                                </div>
                                            }
                                        </span>
                                    </div>
                                </NavLink>
                            </li>
                            <li style={liPadding}>
                                <NavLink
                                    to="/experience"
                                    style={navLinkStyle}
                                    activeStyle={activeNavLinkStyle}
                                >
                                    <i style={iconMR} className="fa fa-briefcase"></i> Experiencias
                                    {
                                        this.props.hasExperienceDataReducer &&
                                        <div style={inline}>
                                            {' '}<i className="fa fa-check"></i>
                                        </div>
                                    }
                                    {
                                        (this.props.isRequiredModuleReducer && !this.props.hasExperienceDataReducer) &&
                                        <div style={isRequiredModule}>
                                            {' '}<i class="fa fa-exclamation"></i>
                                        </div>
                                    }
                                </NavLink>
                            </li>
                            <li style={liPadding}>
                                <NavLink
                                    to="/reference"
                                    style={navLinkStyle}
                                    activeStyle={activeNavLinkStyle}
                                >
                                    <i style={iconMR} className="fa fa-address-book"></i> Referencias
                                    {
                                        this.props.hasReferenceDataReducer &&
                                        <div style={inline}>
                                            {' '}<i className="fa fa-check"></i>
                                        </div>
                                    }
                                    {
                                        (this.props.isRequiredModuleReducer && !this.props.hasReferenceDataReducer) &&
                                        <div style={isRequiredModule}>
                                            {' '}<i class="fa fa-exclamation"></i>
                                        </div>
                                    }
                                </NavLink>
                            </li>
                            <li style={liPadding}>
                                <NavLink
                                    to="/jobAppliedInformation"
                                    style={navLinkStyle}
                                    activeStyle={activeNavLinkStyle}
                                >
                                    <div style={{ display: 'flex' }}>
                                        <i style={iconThinMR} className="fa fa-info-circle"></i>
                                        <span style={{ textAlign: 'justify' }}>
                                            Información del empleo <br /> solicitado
                                            {
                                                this.props.hasJobInformationDataReducer &&
                                                <div style={inline}>
                                                    {' '}<i className="fa fa-check"></i>
                                                </div>
                                            }
                                            {
                                                (this.props.isRequiredModuleReducer && !this.props.hasJobInformationDataReducer) &&
                                                <div style={isRequiredModule}>
                                                    {' '}<i class="fa fa-exclamation"></i>
                                                </div>
                                            }
                                        </span>
                                    </div>
                                </NavLink>
                            </li>
                            <li style={liPadding}>
                                <NavLink
                                    to="/attachments"
                                    style={navLinkStyle}
                                    activeStyle={activeNavLinkStyle}
                                >
                                    <i style={iconMR} className="fa fa-file-alt"></i> Documentos adjuntos
                                    {
                                        this.props.hasAttachmentDataReducer &&
                                        <div style={inline}>
                                            {' '}<i className="fa fa-check"></i>
                                        </div>
                                    }
                                </NavLink>
                            </li>
                        </ul>
                    </aside>
                    <main className={mainClass.join(" ")}>
                        {
                            this.props.loading &&
                            <div className={'display-flex flex-direction-row flex-center'}>
                                <Spinner
                                    animation="grow"
                                    variant="primary"
                                    className={'is-absolute center-spinner-vertically'}
                                    size="lg" />
                            </div>
                        }
                        <Router />
                    </main>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loading: state.loading,
        user: state.user,
        hasPersonalDataReducer: state.hasPersonalDataReducer,
        hasVehicleDataReducer: state.hasVehicleDataReducer,
        hasFamilyStructureDataReducer: state.hasFamilyStructureDataReducer,
        hasEducationDataReducer: state.hasEducationDataReducer,
        hasLanguageDataReducer: state.hasLanguageDataReducer,
        hasKnowledgeDataReducer: state.hasKnowledgeDataReducer,
        hasTalentsDataReducer: state.hasTalentsDataReducer,
        hasExperienceDataReducer: state.hasExperienceDataReducer,
        hasReferenceDataReducer: state.hasReferenceDataReducer,
        hasJobInformationDataReducer: state.hasJobInformationDataReducer,
        hasAttachmentDataReducer: state.hasAttachmentDataReducer,
        isRequiredModuleReducer: state.isRequiredModuleReducer,
    }
}

export default connect(mapStateToProps)(Layout);